var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16667 22C13.25 17.8 17.3333 14.0391 17.3333 9.4C17.3333 4.76081 13.677 1 9.16667 1C4.65635 1 1 4.76081 1 9.4C1 14.0391 5.08333 17.8 9.16667 22Z",
    stroke: "#F2F2F2",
    strokeWidth: 1.44828,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16652 11.4994C10.4552 11.4994 11.4999 10.4548 11.4999 9.1661C11.4999 7.87743 10.4552 6.83276 9.16652 6.83276C7.87782 6.83276 6.83319 7.87743 6.83319 9.1661C6.83319 10.4548 7.87782 11.4994 9.16652 11.4994Z",
    stroke: "#F2F2F2",
    strokeWidth: 1.44828,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationicon);
export default __webpack_public_path__ + "static/media/locationicon.2e7f036444fd73b95b923234ec9e559e.svg";
export { ForwardRef as ReactComponent };